import Product from "../../types/Product";
import ServicesHelper from "./ServicesHelper";

const PRODUCTS_FILE_URL = '/assets/config/products.json';

export const ProductService = { 

    async fetchAllProducts(): Promise<Product[]> {
        const data = await ServicesHelper.fetchAndValidateJSON(PRODUCTS_FILE_URL);
        return data.products.map((product: any) => ({
            id: product.id,
            name: product.name,
            description: product.description,
            resolution: product.resolution,
            filesize: product.filesize,
            price: product.price,
            category: product.category,
            shipping: product.shipping
        }));
    }
}